export enum MediaAssetType {
  Both = `Both`,
  MediaGallery = `MediaGallery`,
  AdvertBanner = `AdvertBanner`,
}
